export const ENV = {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  blogBaseUrl: import.meta.env.VITE_API_BLOG_BASE_URL,
} as const;
